<div class="flex flex-col gap-6 p-6" [dir]="isArabic() ? 'rtl' : 'ltr'">
  @if (presetCompanyId() || presetCategoryId()) {
    <div class="borderTabsColor/20 flex items-center justify-between rounded-lg border bg-red-50 px-4 py-2">
      <span class="textTabsColor text-sm font-medium">
        @if (presetCompanyId()) {
          {{ isArabic() ? "عرض أصناف شركة: " : "Showing products for company: " }} {{ presetCompanyTitle() }}
        }
        @if (presetCategoryId()) {
          {{ isArabic() ? " عرض أصناف فئة: " : "Showing products for Category: " }} {{ presetCategoryTitle() }}
        }
      </span>
    </div>
  }
  <app-product-filters
    [presetCategoryId]="presetCategoryId()"
    [presetMfgCompanyId]="presetCompanyId()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()"
    (toggleSortOrder)="onToggleSortOrder()" />

  @if (isLoading()) {
    <app-loading />
  } @else if (hasError()) {
    <div class="py-8">
      <app-error-data
        title="Something went wrong"
        i18n-title="@@errorTitle"
        description="We couldn't load the products right now. Please try again later."
        i18n-description="@@errorDescription"
        [showRetry]="true"
        (retry)="loadProducts()"></app-error-data>
    </div>
  } @else {
    @if (products().length > 0) {
      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        @for (item of products(); track item.id) {
          <app-product-card-component (activePopup)="onActiveAddToCartPopup($event)" [product]="item" />
        }
      </div>

      @if (totalPages > 1) {
        <div class="flex items-center justify-center gap-2 pt-4">
          <button
            (click)="previousPage()"
            [disabled]="currentPage === 1"
            class="cursor-pointer rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
            {{ isArabic() ? "السابق" : "Previous" }}
          </button>

          @for (page of getPageNumbers(); track page) {
            @if (page === -1) {
              <span class="cursor-pointer px-2 text-gray-400">...</span>
            } @else {
              <button
                (click)="goToPage(page)"
                [class.bgTabsColor]="currentPage === page"
                [class.text-white]="currentPage === page"
                [class.borderTabsColor]="currentPage === page"
                class="hover-bg-primary-10 cursor-pointer rounded-md border border-gray-300 px-3 py-2 text-sm transition-colors">
                {{ page }}
              </button>
            }
          }

          <button
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
            class="cursor-pointer rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
            {{ isArabic() ? "التالي" : "Next" }}
          </button>
        </div>
      }
    } @else {
      <app-empty-data
        [title]="isArabic() ? 'لا توجد اصناف مطابقة لمعايير البحث' : 'No products found matching your criteria'" />
    }
  }
</div>

@if (addToCartPopup()?.active) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="relative w-[340px] rounded-2xl border border-gray-100 bg-white p-6" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="mb-5 flex items-center gap-3">
        <div class="primaryTextColor flex h-9 w-9 items-center justify-center rounded-lg bg-green-50">
          <app-cart-icon type="add" />
        </div>
        <div>
          <p class="primaryTextColor text-sm font-medium" i18n="@@updateQuantity">Update quantity</p>
        </div>
      </div>

      <!-- Quantity -->
      <label class="mb-2 block text-xs text-gray-500" i18n="@@quantity">Quantity</label>
      <div class="mb-5 flex w-fit items-center overflow-hidden rounded-lg border border-gray-200">
        <button
          (click)="increaseQty()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center border-r border-gray-100 bg-gray-50 outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 13h8v8h2v-8h8v-2h-8V3h-2v8H3z" />
          </svg>
        </button>
        <input
          [(ngModel)]="itemQuantity"
          (ngModelChange)="onQuantityChange($event)"
          (change)="errorQuantity()"
          type="number"
          class="h-9 w-13 border-none text-center text-sm font-medium outline-none" />
        <button
          (click)="decreaseQty()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center border-l border-gray-100 bg-gray-50 outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 11h18v2H3z" />
          </svg>
        </button>
      </div>

      @if (errorQty()) {
        <p class="mb-2 text-xs font-light text-red-500">
          {{ errorQty() }}
        </p>
      }

      <!-- Total -->
      <div class="mb-4 flex items-center justify-between border-t border-gray-100 py-2.5">
        <span class="text-xs text-gray-400" i18n="@@thTotalPrice">Total</span>
        <span class="rtl text-base font-medium text-gray-900" dir="rtl">
          {{ addToCartPopup()?.productPrice | currency: "EGP" : "symbol" : "1.2-2" : "ar-EG" }}
        </span>
      </div>

      @if (isErrorCart()) {
        <div class="my-4">
          <app-error [apiError]="isErrorCart()" />
        </div>
      }

      <!-- Actions -->
      <div class="flex gap-2">
        <button
          class="h-9 flex-1 cursor-pointer rounded-lg border border-gray-200 text-sm text-gray-500"
          i18n="@@cancel"
          (click)="addToCartPopup.set(null)">
          Cancel
        </button>
        <button
          (click)="onAddToCart()"
          class="bgPrimary h-9 flex-1 cursor-pointer rounded-lg border border-gray-200 text-sm font-medium text-white">
          @if (isAddingToCart()) {
            <span i18n="@@loading">loading...</span>
          } @else {
            <span i18n="@@addToCart">Add To Cart</span>
          }
        </button>
      </div>
    </div>
  </div>
}
